import { Grid, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Input,
  InputAuto,
  InputImg,
  InputPass,
  Select,
} from "../../../controls";
import { DropLi, Model, UseForm } from "../../../hooks";
import { Alert, Form } from "../../../layout";
import * as actions from "../../../api/actions/actions";
import { controller, endpoints } from "../../../api/actions/api";
import { RmvEmptyProp, ToFormData } from "../../../hooks/Method";
import { PassValidation } from "../../../utils";

const AddEditUser = (props) => {
  const { _getById, _post, _put, _defHoa } = props;
  const { id } = useParams();
  const navigate = useNavigate();
  const { Countries, Roles } = DropLi();
  const { UserMdl } = Model();
  const [hideZip, setHideZip] = useState(true);
  const {
    values,
    setValues,
    errors,
    setErrors,
    passValid,
    handleInpChg,
    handleInpPass,
    handleFile,
    resetFormControls,
  } = UseForm(UserMdl);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    const onComplete = (res) => {
      res.status === 200 &&
        setValues({ ...values, ...RmvEmptyProp(res.result) });
    };
    id && _getById(endpoints.User + controller.GetById, id, null, onComplete);
    return () => {
      resetFormControls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const validateForm = () => {
    let temp = {};
    temp.fullName = values.fullName !== "" ? "" : "Name is required.";
    temp.email = values.email !== "" ? "" : "Email is required.";
    temp.phone = values.phone !== "" ? "" : "Phone is required.";
    temp.role = values.role !== "" ? "" : "Role is required.";
    if (values.id === 0) {
      temp.password =
        values.password !== ""
          ? passValid.passValid
            ? ""
            : " "
          : "Password is required.";
      temp.confirmPass =
        values.confirmPass !== ""
          ? values.confirmPass === values.password
            ? ""
            : "Password and Confirm password not match"
          : "Confirm Password is required.";
    }
    temp.address1 = values.address1 !== "" ? "" : "Address line is required.";
    temp.city = values.city !== "" ? "" : "City is required.";
    temp.country = values.country !== "" ? "" : "Country is required.";
    temp.state = values.state !== "" ? "" : "State is required.";
    if (hideZip) temp.zip = values.zip !== "" ? "" : "Zip is required.";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res.status === 201 || res.status === 200) {
          setAlert({
            isOpen: true,
            type: "success",
            title: "Success",
            subTitle: `User ${id ? "Update" : "Added"} Successfully.`,
            onClick: () => navigate("/my_account/users"),
          });
        } else if (res.status === 409)
          setErrors((x) => ({ ...x, email: res.msg }));
        else
          setAlert({
            isOpen: true,
            type: "error",
            title: "Error",
            subTitle: res.msg,
          });
      };

      if (values.id === 0) {
        values.hoaId = _defHoa.id;
        values.orgId = _defHoa.orgId;
        _post(
          endpoints.User + controller.Post,
          ToFormData(RmvEmptyProp(values)),
          actions.ActionType.Data,
          onComplete
        );
      } else if (values.id !== 0) {
        _put(
          endpoints.User + controller.Put,
          ToFormData(RmvEmptyProp(values)),
          actions.ActionType.Data,
          onComplete
        );
      }
    }
  };

  useEffect(() => {
    if (values.country === "JM") {
      setHideZip(false);
      setValues((x) => ({ ...x, zip: "" }));
    } else setHideZip(true);
    return () => {
      setHideZip(true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.country]);

  return (
    <>
      <Paper className="p-20">
        <Form onSubmit={handleSubmit} noValidate>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <div className="mb-10 d-flex j-between a-center">
                <div>
                  <h2 className="h tx-md fw-5 mb-5 tx-upp border-left">
                    {id ? "Edit" : "Add"} User
                  </h2>
                </div>

                <div>
                  <Button type="submit" loading={loading}>
                    {id ? "Save Changes" : "Submit"}{" "}
                  </Button>
                </div>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="d-flex a-center pl-5">
                <span className="dark-color tx-upp" style={{ width: "120px" }}>
                  User Info
                </span>
                <div className="bs-secondary w-100pr" />
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label="Full Name"
                name="fullName"
                value={values.fullName}
                error={errors.fullName}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label="Phone"
                name="phone"
                value={values.phone}
                error={errors.phone}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <InputAuto
                label="Country"
                name="country"
                value={values.country}
                error={errors.country}
                onChange={handleInpChg}
                options={Countries}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Input
                label="City"
                name="city"
                value={values.city}
                error={errors.city}
                onChange={handleInpChg}
                inputProps={{ maxLength: 200 }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Input
                label={!hideZip ? "Parish" : "State"}
                name="state"
                value={values.state}
                error={errors.state}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
            {hideZip && (
              <Grid item xs={12} md={3}>
                <Input
                  label="ZIP"
                  name="zip"
                  value={values.zip}
                  error={errors.zip}
                  onChange={handleInpChg}
                  fullWidth
                />
              </Grid>
            )}
            <Grid item xs={12} md={6}>
              <Input
                label="Address Line - 1"
                name="address1"
                multiline
                rows={2}
                value={values.address1}
                error={errors.address1}
                onChange={handleInpChg}
                inputProps={{ maxLength: 500 }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label="Address Line - 2"
                name="address2"
                multiline
                rows={2}
                value={values.address2}
                error={errors.address2}
                onChange={handleInpChg}
                inputProps={{ maxLength: 500 }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <div className="d-flex a-center pl-5">
                <span className="dark-color tx-upp" style={{ width: "120px" }}>
                  Access
                </span>
                <div className="bs-secondary w-100pr" />
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <Select
                label="Role"
                name="role"
                value={values.role}
                error={errors.role}
                onChange={handleInpChg}
                options={Roles}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label="Email"
                name="email"
                value={values.email}
                error={errors.email}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
            {!values.id && (
              <>
                <Grid item xs={12} md={6}>
                  <InputPass
                    label="Password"
                    name="password"
                    value={values.password}
                    onChange={handleInpPass}
                    error={errors.password}
                    className="input-primary w-100pr"
                  />
                  <PassValidation
                    {...{ password: values.password, passValid }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputPass
                    label="Confirm Password"
                    name="confirmPass"
                    value={values.confirmPass}
                    onChange={(e) => handleInpPass(e, true)}
                    error={errors.confirmPass}
                    className="input-primary w-100pr"
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12} md={3}>
              <InputImg
                label="Photo"
                name="photoFile"
                src={values.photo}
                rmv={() => {
                  setValues({ ...values, photoFile: "", photo: "" });
                }}
                onChange={handleFile}
                error={errors.photoFile}
              />
            </Grid>
          </Grid>
        </Form>
      </Paper>

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

const mapStateToProps = (state) => ({
  _authUser: state.storeData.authUser,
  _defHoa: state.storeData.defHoa,
});

const mapActionToProps = {
  _post: actions.post,
  _put: actions.put,
  _getById: actions.getById,
};

export default connect(mapStateToProps, mapActionToProps)(AddEditUser);
